export const editMutations = <const>{
	KOREKCE_KOD_SELECT_MAPPER: 'KOREKCE_KOD_SELECT_MAPPER',
	KOREKCE_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'KOREKCE_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
